import { isNullish } from '@witmetrics/utils/misc';
import { getAccountsUrl } from '@/api/urls';

export const classes = {
  dialog: 'w-[90vw] max-w-[480px]',
  body: 'flex flex-col items-center gap-4 p-6',
  summaryLabel: 'text-sm text-grey-7 uppercase tracking-wide dark:text-mauve-3',
  summaryValue:
    'text-4xl font-semibold text-grey-9 tabular-nums mt-1 dark:text-mauve-1',
  description: 'text-sm text-grey-7 text-center dark:text-mauve-2',
  link: 'inline-flex items-center justify-center rounded-2xl bg-orange-3 px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-orange-3',
};

export function formatCredits(credits: number | undefined) {
  if (isNullish(credits)) return '—';
  return credits.toLocaleString('en-US');
}

export function buildCreditsUrl(
  accountType: 'PRACTICE' | 'LAB',
  accountId: number
) {
  const base = getAccountsUrl();
  if (accountType === 'PRACTICE') {
    return `${base}/dashboard/practices/?practiceId=${accountId}&activeTab=credits`;
  }
  return `${base}/dashboard/labs/?labId=${accountId}&activeTab=credits`;
}
